export default "__VITE_ASSET__EHws0cef__"